// extracted by mini-css-extract-plugin
export default {"row":"ArrangeSection_row__rFJcY","alignGrid":"ArrangeSection_alignGrid__gQxn7"};